import { render, staticRenderFns } from "./TableTest.vue?vue&type=template&id=314adc67"
import script from "./TableTest.vue?vue&type=script&lang=js"
export * from "./TableTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports